import styles from './styles.module.scss';
import { DailySunlightResult } from '@/types/sunlight';

interface FacadePointDataProps {
	data: DailySunlightResult;
}

const formatDate = (date: string | null | undefined) => {
	if (!date) return 'N/A';
	const parsed = new Date(date);
	if (Number.isNaN(parsed.getTime())) return 'N/A';
	return parsed.toLocaleDateString();
};


export const FacadePointData = ({ data }: FacadePointDataProps) => {
	const hours = data.averageDailySunlightHours ?? 0;
	const hoursColor = hours > 6 ? '#00FF00' : hours > 4 ? '#FFD700' : '#FF6B6B';

	return (
		<div>
			<div className={styles.header}>
				<span className={styles.title}>Facade Point</span>
			</div>

			<div className={styles.primary}>
				<div className={styles.mainMetric} style={{ color: hoursColor }}>
					{hours.toFixed(1)} hrs/day
				</div>
				<div className={styles.consistency}>
					<span className={styles.label}>Average Daily Sunlight</span>
				</div>
			</div>

			<div className={styles.stats}>
				<div className={styles.statRow}>
					<span className={styles.statLabel}>Days with sunlight:</span>
					<span className={styles.statValue}>
						{data.daysWithSunlight}/{data.totalDaysAnalyzed}
					</span>
				</div>
				<div className={styles.statRow}>
					<span className={styles.statLabel}>Morning / Afternoon:</span>
					<span className={styles.statValue}>
						{(data.morningHoursPercent ?? 0).toFixed(0)}% / {(data.afternoonHoursPercent ?? 0).toFixed(0)}%
					</span>
				</div>
				<div className={styles.statRow}>
					<span className={styles.statLabel}>Spring / Summer:</span>
					<span className={styles.statValue}>
						{(data.springMonthsAverage ?? 0).toFixed(1)}h / {(data.summerMonthsAverage ?? 0).toFixed(1)}h
					</span>
				</div>
				<div className={styles.statRow}>
					<span className={styles.statLabel}>Fall / Winter:</span>
					<span className={styles.statValue}>
						{(data.fallMonthsAverage ?? 0).toFixed(1)}h / {(data.winterMonthsAverage ?? 0).toFixed(1)}h
					</span>
				</div>
				<div className={styles.statRow}>
					<span className={styles.statLabel}>Primary sun direction:</span>
					<span className={styles.statValue}>{data.primarySunDirection ?? 'N/A'}</span>
				</div>
			</div>

			<div className={styles.meta}>
				<div className={styles.metaRow}>
					<span className={styles.metaLabel}>First light:</span>
					<span className={styles.metaValue}>{formatDate(data.firstSunlightDate)}</span>
				</div>
				<div className={styles.metaRow}>
					<span className={styles.metaLabel}>Last light:</span>
					<span className={styles.metaValue}>{formatDate(data.lastSunlightDate)}</span>
				</div>
				<div className={styles.metaRow}>
					<span className={styles.metaLabel}>Location:</span>
					<span className={styles.metaValue}>
						({data.point.x.toFixed(1)}, {data.point.y.toFixed(1)}, {data.point.z.toFixed(1)})
					</span>
				</div>
				<div className={styles.metaRow}>
					<span className={styles.metaLabel}>Zero-light days:</span>
					<span className={styles.metaValue}>{data.zeroDaysCount ?? 0}</span>
				</div>
			</div>
		</div>
	);
};
